import React from 'react';
import AtlasEmptyState from './AtlasEmptyState';
import OfflineBadge from './OfflineBadge';
import NediEmptyState from '../nedi/NediEmptyState';
import { t } from '../../i18n';
import './WorkspaceStatus.css';

function WorkspaceStatus({
  loading,
  error,
  empty,
  retry,
  onRetry,
  onImport,
  emptyTitle,
  emptyMessage,
  emptyCta,
  offline,
  offlineCachedAt,
  children,
}) {
  const showOfflineBadge = Boolean(offline || offlineCachedAt);
  // IDB hydrate: show cached workspace + badge, not the hard error panel.
  const hardError = error && !offlineCachedAt;

  if (loading) {
    return (
      <div className="av-workspace-status av-workspace-status--loading" role="status" aria-busy="true">
        <div className="av-workspace-spinner" />
        <span>{t('web.status.loading')}</span>
      </div>
    );
  }

  if (hardError) {
    return (
      <div className="av-workspace-status av-workspace-status--error" role="alert">
        <NediEmptyState
          title={t('web.status.error.title')}
          message={error || t('web.status.error.network')}
          actionLabel={onRetry ? t('web.status.retry') : undefined}
          onAction={onRetry}
          actionVariant="primary"
        />
      </div>
    );
  }

  if (empty) {
    return (
      <div className="av-workspace-status av-workspace-status--empty">
        {showOfflineBadge ? (
          <div className="av-workspace-status__offline">
            <OfflineBadge cachedAt={offlineCachedAt} />
          </div>
        ) : null}
        <AtlasEmptyState
          title={emptyTitle || t('web.status.empty.title')}
          message={emptyMessage || t('web.status.empty.message')}
          actionLabel={onImport ? (emptyCta || t('web.status.empty.cta')) : undefined}
          onAction={onImport}
        />
      </div>
    );
  }

  if (showOfflineBadge) {
    return (
      <>
        <div className="av-workspace-status__offline">
          <OfflineBadge cachedAt={offlineCachedAt} />
        </div>
        {children}
      </>
    );
  }

  return children;
}

export default WorkspaceStatus;
